export enum SoundSignalType {
  HIGH_COMPR = 'HIGH_COMPR',
  ADPCM_4BIT = 'ADPCM_4BIT',
  PCM_16BIT = 'PCM_16BIT',
  PCM_24BIT = 'PCM_24BIT',
  RUN_LEN_HUFFMAN = 'RUN_LEN_HUFFMAN',
  ADPCM_6BIT = 'ADPCM_6BIT',
}
